var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { unstable_capitalize } from '@mui/utils';
import { Chip as MuiChip, styled } from '@mui/material';
import React, { forwardRef } from 'react';
var SMuiChip = styled(MuiChip, {
    shouldForwardProp: function (prop) { return prop !== 'rounded'; },
    name: 'MuiChip',
    overridesResolver: function (_a) {
        var color = _a.color, rounded = _a.rounded, theme = _a.theme;
        var customOverrides = theme.components.MuiChip.customOverrides;
        return [
            customOverrides["color".concat(unstable_capitalize(color))],
            rounded && customOverrides.rounded,
        ];
    },
})({});
var Chip = forwardRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? 'neutral' : _b, rounded = _a.rounded, props = __rest(_a, ["color", "rounded"]);
    return (
    //@ts-ignore
    React.createElement(SMuiChip, __assign({}, __assign({ color: color, rounded: rounded }, props), { ref: ref })));
});
Chip.displayName = 'Chip';
export default Chip;
